import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store";
import { computed, onMounted, ref, watch } from "vue";
import CheckoutService from "@/services/checkout.service";
import { StorageService } from "@/core";
import { injectParentValidator } from "@/core/app.service";
import { useGoogleMapsAddressValidation } from "./google-maps-address-validation.composable";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerDetailsB2C',
  props: {
    model: null,
    value: null,
    taxCalculationErrorMessage: null,
    alternativeDelivery: { type: Boolean },
    selectedCustomerCountryValue: null
  },
  emits: ["input", "shouldLoadPickups", "changeCustomerCountry", "changeTaxField"],
  setup(__props: any, { emit }: { emit: ({(e: "input", value: InvoiceAddress): void,
    (e: "shouldLoadPickups", value: boolean): void,
    (e: "changeCustomerCountry", value: InvoiceAddressCountryViewObject): void,
    (e: "changeTaxField"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    model: CheckoutPageViewModel,
    value?: InvoiceAddress,
    taxCalculationErrorMessage?: string,
    alternativeDelivery?: boolean,
    selectedCustomerCountryValue?: InvoiceAddressCountryViewObject
}




const form = ref<InvoiceAddress>(props.value);

const basket = computed<BasketViewModel>(() => store.getters["basket/basket"]);

const phoneRegex = /^[+]{0,1}[- +0-9]*$/;
const selectedCustomerCountry = ref<InvoiceAddressCountryViewObject>({} as InvoiceAddressCountryViewObject);
const selectedCustomerState = ref<StateViewObject>({} as StateViewObject);

const isNonUSDelivery = computed(() => selectedCustomerCountry.value.id !== "US");
const { validateAddress } = useGoogleMapsAddressValidation({ form, model: props.model });
const states = computed(() => {
    if (!props.model.countryStates) {
        return [];
    }
    if (selectedCustomerCountry.value.id) {
        return props.model.countryStates.find(x => x.country === selectedCustomerCountry.value.id).states;
    }

    return props.model.countryStates.find(x => x.country === props.model.invoiceAddressCountries[0].id).states;
});

// Inject validator
injectParentValidator();

watch(() => props.value, onCustomerDetailsChange, { deep: true });

function onCustomerDetailsChange() {
    form.value = props.value;
    emit("input", form.value);
    setSelectedCountryAndState();
}

onMounted(() => {
    setSelectedCountryAndState();
    if (selectedCustomerCountry.value !== undefined) {
        const customer = Object.assign(props.value, { countryCode: selectedCustomerCountry.value.id });
        emit("input", customer);
    }
});

function setSelectedCountryAndState() {
    const defaultCountry = props.model.invoiceAddressCountries[0];

    if (props.model.invoiceAddressCountries.length === 1) {
        selectedCustomerCountry.value = defaultCountry;
    } else {
        selectedCustomerCountry.value = props.model.invoiceAddressCountries.find(c => c.id === form.value.countryCode) || defaultCountry;
    }

    const selectedStates = props.model.countryStates.find(x => x.country === selectedCustomerCountry.value.id);
    selectedCustomerState.value = selectedStates ? selectedStates.states.find(c => c.code === form.value.extendedFields.stateCode) : null;
}
watch(() => selectedCustomerCountry.value, onSelectedCustomerCountryChange);

function onSelectedCustomerCountryChange() {
    emit("changeCustomerCountry", selectedCustomerCountry.value);
}

function onCustomerStateChanged(state: StateViewObject) {
    const customer = Object.assign(form.value, { extendedFields: Object.assign(form.value.extendedFields, { stateCode: state.code }) });
    emit("input", customer);
    setCustomerInLocalStorage(customer);
    emit("changeTaxField");
}

function blur() {
    setCustomerInLocalStorage(form.value);
    if (form.value.address && form.value.postalCode && !props.model.isUsMarket) {
        emit("shouldLoadPickups", true);
    }
    if (form.value.address && form.value.postalCode && props.model.isUsMarket) {
        validateAddress();
    }
}

function setCustomerInLocalStorage(value) {
    StorageService.setItemAs(CheckoutService.customerLocalStorageKey, value);
}

return { __sfc: true,props, emit, form, basket, phoneRegex, selectedCustomerCountry, selectedCustomerState, isNonUSDelivery, validateAddress, states, onCustomerDetailsChange, setSelectedCountryAndState, onSelectedCustomerCountryChange, onCustomerStateChanged, blur, setCustomerInLocalStorage }
}

})